import axios from 'axios'
import {
    API_URL_PATH,
    STATUS_PATH,
    SHOPIFY_PATH,
    ORDERS_PATH,
    GET_ORDER_EVENTS,
    SEND_SMS,
    CONTACT_PATH,
    PASSWORD_PATH,
    GET_PDF_RECEIPT,
    TIENDANUBE_AUTHORIZE_PATH,
    TRACKING_PATH,
    GET_LOCKERSIZES_BY_ORDERID,
    ORDER_CANCEL,
    ORDER_LIST_CANCEL,
    ORDER_READY,
    ORDER_CREATE_RESERVE,
    REGISTRATION_PATH,
    SHOP_INFO_PATH,
    WOOCOMMERCE_PATH,
    GETCOUNTRIES_PATH,
    GETCOUNTRYSUBDIVISIONS_PATH,
    GETEULA_PATH,
    ACCEPTEULA_PATH,
    SHOPCONFIG_GET_PATH,
    SHOPCONFIG_POST_PATH,
    RESET_PASSWORD_PATH,
    RESET_PASSWORD_ASSIGNMENT_PATH,
    LOCKER_PATH,
    GETTAXINGCATEGORYLIST_PATH,
    GETSHOPTYPELIST_PATH,
    GETCUITINFO_PATH,
    GET_BILLING_INFORMATION_PATH,
    SET_BILLING_INFORMATION_PATH,
    GET_SHIPPINGRATES_PATH,
    CREATE_NEWORDER_PATH,
    WAREHOUSE_INFO_PATH,
    ORDER_READY_ALL,
    GET_PDF_RECEIPTS,
    VALIDATENEWSHOPNAME_PATH,
    GET_SERVICE_AREA_CONFIG_PATH,
    SET_SERVICE_AREA_CONFIG_PATH,
    PRICE_PATH,
    GET_DOOR_SIZES,
    GET_MOVEMENTS_SUMMARY_PATH,
    GET_MOVEMENTS_EXCEL_PATH,
    SHOPCONFIG_GET_NEW_CLIENT_SECRET_PATH,
    ORDER_RETURN,
    GETORDERADDRESS_PATH,
    UPDATEORDERADDRESS_PATH,
    ORDER_EXTEND,
    ORDER_EXTENDINFO,
    ORDER_INSURE_DATA_PATH,
    ORDER_INSURE_PATH,
    DISPATCH_TO_LOCKER_PATH,
    ORDER_IMPORTER_GET_DOORSIZES_PATH,
    ORDER_IMPORTER_GET_LOCKERS_PATH,
    ORDER_IMPORTER_CREATE_ORDERS_PATH,
    ORDER_DOOR_SIZE_UPDATE_PATH,
    NEWS_GET_ALL_NEWS,
    NEWS_SET_AS_READ,
    NEWS_SET_AS_VIEW,
    ORDER_GET_RECOVERY_LABEL,
    ORDER_GET_RECOVERY_BARCODE,
    CANCEL_PARCEL,
    ORDER_GET_DELIVERY_RECEIPT_LABEL,
    ADD_ORDER_TO_GROUP_READY_FOR_COLLECT_PATH,
    REMOVE_ORDER_TO_GROUP_READY_FOR_COLLECT_PATH,
    APPCONFIG_PATH,
    UPDATE_CONTACT_TIME_PATH,
    GET_CONTACT_TIME_PATH
} from '../server/connection'
import * as queryString from 'querystring'
import { getToken } from './authHelpers'
import { getUrlVars } from '../utils/html'

const axiosPostRequestConfig = {
    headers: {
        'Content-type': 'application/x-www-form-urlencoded',
    },
}

export const downloadFile = (url) =>
    new Promise((resolve, reject) => {
        axios
            .get(url, {
                responseType: 'arraybuffer',
            })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const blobToDownloadedFile = (blob, fileName) => {
    const url = window.URL.createObjectURL(new Blob([blob]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
}

export const userPasswordLogin = (username, password) =>
    new Promise((resolve, reject) => {
        const data = {
            grant_type: 'password',
            username: username,
            password: password,
        }
        getToken(data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const changePassword = (passwordOld, passwordNew) =>
    new Promise((resolve, reject) => {
        const data = queryString.stringify({
            passwordOld: passwordOld,
            passwordNew: passwordNew,
        })
        axios
            .post(
                API_URL_PATH + PASSWORD_PATH + '/change',
                data,
                axiosPostRequestConfig
            )
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const tiendanubeAutorize = (queryStringParams) =>
    new Promise((resolve, reject) => {
        const data = queryString.stringify({
            code: getUrlVars(queryStringParams)['code'],
            queryString: queryStringParams,
        })
        axios
            .post(
                API_URL_PATH + TIENDANUBE_AUTHORIZE_PATH,
                data,
                axiosPostRequestConfig
            )
            .then((response) => resolve(response.data))
            .catch((error) => reject(error))
    })

export const shopifyLogIn = (queryStringParams) =>
    new Promise((resolve, reject) => {
        const data = {
            grant_type: 'shopify',
            queryString: queryStringParams,
        }
        getToken(data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const shopifyAuthResult = (queryStringParams) =>
    new Promise((resolve, reject) => {
        const data = queryString.stringify({
            code: getUrlVars(queryStringParams)['code'],
            queryString: queryStringParams,
        })

        axios
            .post(
                API_URL_PATH + SHOPIFY_PATH + '/AuthResult',
                data,
                axiosPostRequestConfig
            )
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const wooCommerceGetStatus = (queryStringParams) =>
    new Promise((resolve, reject) => {
        const token = getUrlVars(queryStringParams)['token']

        axios
            .get(
                API_URL_PATH + WOOCOMMERCE_PATH + '/getStatus?token=' + token,
                axiosPostRequestConfig
            )
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getStatus = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + STATUS_PATH)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getAppConfig = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + APPCONFIG_PATH)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getEula = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GETEULA_PATH)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const acceptEula = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(
                API_URL_PATH +
                ACCEPTEULA_PATH +
                '?' +
                queryString.stringify(data),
                axiosPostRequestConfig
            )
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getOrders = (data) =>
    new Promise((resolve, reject) => {
        if (data.orderStateId === 99) {
            data.orderStateId = 1
        }
        axios
            .get(API_URL_PATH + ORDERS_PATH + '/Get', { params: data })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getGroupReadyForCollect = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + '/GetGroupReadyForCollect')
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getOrdersForExport = (data) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + '/GetOrdersForExport', { params: data })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const sendContact = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(
                API_URL_PATH + CONTACT_PATH + '/Send',
                queryString.stringify(data),
                axiosPostRequestConfig
            )
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const sendRegistration = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + REGISTRATION_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getShopInfo = (token) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + SHOP_INFO_PATH, { params: { token: token } })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getWarehouseInfo = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + WAREHOUSE_INFO_PATH)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getConfig = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + SHOPCONFIG_GET_PATH)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const postConfig = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + SHOPCONFIG_POST_PATH, data)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getPrices = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + PRICE_PATH)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const postPrices = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + PRICE_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getOrderEvents = (id) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + '/' + id + '/' + GET_ORDER_EVENTS)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const sendSms = (id) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + '/' + SEND_SMS + '?orderId=' + id)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getTrackingFormEvents = (code) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + TRACKING_PATH, { params: { id: code } })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const downloadOrder = (orderId) =>
    new Promise((resolve, reject) => {
        try {
            axios
                .get(
                    API_URL_PATH +
                    ORDERS_PATH +
                    '/' +
                    GET_PDF_RECEIPT +
                    '?orderId=' +
                    orderId,
                    { responseType: 'blob' }
                )
                .then((response) => {
                    return resolve(response)
                })
                .catch((err) => {
                    return reject(err)
                })
        } catch (e) {
            return reject(e)
        }
    })

export const downloadAllOrder = (orderIds, perPage) =>
    new Promise((resolve, reject) => {
        try {
            axios
                .get(
                    API_URL_PATH +
                    ORDERS_PATH +
                    '/' +
                    GET_PDF_RECEIPTS +
                    '?' +
                    orderIds.map((x) => 'id=' + x).join('&') +
                    '&perPage=' +
                    (perPage || 1),
                    { responseType: 'blob' }
                )
                .then((response) => {
                    return resolve(response)
                })
                .catch((err) => {
                    return reject(err)
                })
        } catch (e) {
            return reject(e)
        }
    })

export const getFileNameFromContentDisposition = (headers, defaultName) => {
    if (headers && headers['content-disposition']) {
        var disposition = headers['content-disposition']
        if (disposition && disposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            var matches = filenameRegex.exec(disposition)
            if (matches != null && matches[1]) {
                return matches[1].replace(/['"]/g, '')
            }
        }
    }
    return defaultName
}

export const getLockerSizesByOrderId = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + '/' + GET_LOCKERSIZES_BY_ORDERID + '?orderId=' + orderId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getDoorSizes = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + '/' + GET_DOOR_SIZES)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const orderCancel = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + '/' + ORDER_CANCEL + '?orderId=' + orderId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const orderListCancel = (orderIds) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + ORDER_LIST_CANCEL + '?orderId=' + orderIds)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const orderExtendInfo = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + ORDER_EXTENDINFO + '?orderId=' + orderId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const orderExtend = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + ORDER_EXTEND + '?orderId=' + orderId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const orderReturn = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + '/' + ORDER_RETURN + '?orderId=' + orderId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getOrderAddress = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(
                API_URL_PATH +
                ORDERS_PATH +
                '/' +
                GETORDERADDRESS_PATH +
                '?orderId=' +
                orderId
            )
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const updateOrderAddress = (orderAddress) =>
    new Promise((resolve, reject) => {
        axios
            .post(
                API_URL_PATH + ORDERS_PATH + '/' + UPDATEORDERADDRESS_PATH,
                orderAddress
            )
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const AddOrderToGroupReadyForCollect = (orderIds) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + ORDERS_PATH + ADD_ORDER_TO_GROUP_READY_FOR_COLLECT_PATH, orderIds)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const RemoveOrderToGroupReadyForCollect = (orderIds) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + ORDERS_PATH + REMOVE_ORDER_TO_GROUP_READY_FOR_COLLECT_PATH, orderIds)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const orderReadyAll = (orderIds) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + ORDERS_PATH + '/' + ORDER_READY_ALL, orderIds)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const orderReserve = (orderId, sizeId) =>
    new Promise((resolve, reject) => {
        axios
            .get(
                API_URL_PATH +
                ORDERS_PATH +
                ORDER_CREATE_RESERVE +
                '?orderId=' +
                orderId
            )
            .then((response) => {
                resolve(response.data)
            })
            .catch((err) => reject(err))
    })

export const getCountries = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GETCOUNTRIES_PATH, {})
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getCountrySubdivisions = (countryName) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GETCOUNTRYSUBDIVISIONS_PATH, {
                params: { countryId: countryName },
            })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getTaxingCategoryList = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GETTAXINGCATEGORYLIST_PATH, {})
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getShopTypeList = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GETSHOPTYPELIST_PATH, {})
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getCuitInformation = (cuit) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GETCUITINFO_PATH, { params: { cuit: cuit } })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const resetPassword = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + RESET_PASSWORD_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const resetPasswordAssignment = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + RESET_PASSWORD_ASSIGNMENT_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getLockers = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + LOCKER_PATH + '/getLockers')
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getBillingInformation = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GET_BILLING_INFORMATION_PATH)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const setBillingInformation = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + SET_BILLING_INFORMATION_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getShippingRates = (cp, orderType, doorSizeId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GET_SHIPPINGRATES_PATH, {
                params: { cp, orderType, doorSizeId },
            })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const createNewOrder = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + CREATE_NEWORDER_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const dispatchToLocker = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + DISPATCH_TO_LOCKER_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const validateNewShopName = (shopName) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + VALIDATENEWSHOPNAME_PATH, {
                params: { shopName: shopName },
            })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getServiceAreaConfig = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GET_SERVICE_AREA_CONFIG_PATH)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const setServiceAreaConfig = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + SET_SERVICE_AREA_CONFIG_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getMovementsSummary = (dateFrom, dateTo) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GET_MOVEMENTS_SUMMARY_PATH, {
                params: { dateFrom, dateTo },
            })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getMovementsExcel = (dateFrom, dateTo) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + GET_MOVEMENTS_EXCEL_PATH, {
                params: { dateFrom, dateTo },
                responseType: 'arraybuffer',
            })
            .then((response) => {
                blobToDownloadedFile(response.data, 'Movimientos.xlsx')
                resolve()
            })
            .catch((err) => reject(err))
    })

export const getNewClientSecret = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + SHOPCONFIG_GET_NEW_CLIENT_SECRET_PATH)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const orderInsureData = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDER_INSURE_DATA_PATH + '?orderId=' + orderId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const orderInsure = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + ORDER_INSURE_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const orderImporterGetDoorSizes = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDER_IMPORTER_GET_DOORSIZES_PATH)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const orderImporterGetLockers = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDER_IMPORTER_GET_LOCKERS_PATH)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const orderImporterCreateOrders = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + ORDER_IMPORTER_CREATE_ORDERS_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const doorSizeUpdate = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + ORDER_DOOR_SIZE_UPDATE_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getNews = () =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + NEWS_GET_ALL_NEWS)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const setNewAsRead = (newId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + NEWS_SET_AS_READ + newId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const setNewAsView = (newId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + NEWS_SET_AS_VIEW + newId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getRecoveryLabel = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(
                API_URL_PATH +
                ORDER_GET_RECOVERY_LABEL +
                '?orderId=' +
                orderId,
                { responseType: 'blob' }
            )
            .then((response) => {
                return resolve(response.data)
            })
            .catch((err) => reject(err))
    })

export const getRecoveryBarCode = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDER_GET_RECOVERY_BARCODE + '?orderId=' + orderId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const cancelParcel = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + CANCEL_PARCEL + '?orderId=' + orderId)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })

export const getDeliveryReceiptLabel = (orderId) =>
    new Promise((resolve, reject) => {
        axios
            .get(
                API_URL_PATH +
                ORDER_GET_DELIVERY_RECEIPT_LABEL +
                '?orderId=' +
                orderId,
                { responseType: 'blob' }
            )
            .then((response) => {
                return resolve(response.data)
            })
            .catch((err) => reject(err))
    })

export const setContactTime = (data) =>
    new Promise((resolve, reject) => {
        axios
            .post(API_URL_PATH + ORDERS_PATH + UPDATE_CONTACT_TIME_PATH, data)
            .then((response) => resolve(response))
            .catch((err) => reject(err))
    })

export const getContactTime = (courierParcelId) =>
    new Promise((resolve, reject) => {
        axios
            .get(API_URL_PATH + ORDERS_PATH + GET_CONTACT_TIME_PATH, { params: { courierParcelId: courierParcelId } })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err))
    })